import { reviews } from "@/mocks/categories";

export default function ReviewsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
              User Reviews
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Trusted By <span className="italic text-primary-500">Thousands</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-xl">
            Hear from real users who have transformed their product research with <strong>Hipobuy Spreadsheet</strong> tools and guides.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 flex flex-col"
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < review.rating ? "ri-star-fill text-primary-400" : "ri-star-fill text-background-300"}`}
                  ></i>
                ))}
              </div>

              {/* Title */}
              <h4 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                Exactly what I needed for product research
              </h4>

              {/* Review Text */}
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                {review.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/50">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-secondary-200 shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}